import services from 'services';
import {describeThrow} from 'utils/errors';
import {pipe, prop, map} from 'ramda';
import * as normalize from 'utils/normalize';
import {getResponseData} from 'utils/app';
import msgs from 'dicts/messages';

let httpJson = null;
services.waitFor('api').then(x => (httpJson = x.httpJson));
let intl = null;
services.waitFor('intl').then(x => (intl = x));

export const getBuildings = query =>
	httpJson('get', `/buildings/projectSearch`, query)
		.catch(describeThrow(intl.formatMessage({id: 'Failed to search buildings'})))
		.then(prop('data'));

export const postCondo = condo =>
	httpJson('post', '/condominiums', {}, {body: condo})
		.catch(describeThrow(intl.formatMessage({id: 'Failed to save'})))
		.then(getResponseData(normalize.condo));

export const createProjectComment = (projectId, comment) =>
	httpJson('post', `/projectComments`, {projectId}, {body: comment}).catch(
		describeThrow(intl.formatMessage({id: msgs.saveFailed})),
	);

export const updateProjectComment = (projectId, commentId, comment) =>
	httpJson('put', `/projectComments/${commentId}`, {projectId}, {body: comment}).catch(
		describeThrow(intl.formatMessage({id: msgs.saveFailed})),
	);

export const getProjectComments = (projectId, query) =>
	httpJson('get', `/projectComments`, {projectId, ...query}).catch(
		describeThrow(intl.formatMessage({id: msgs.contentFetchFailed})),
	);

export const deleteProjectComment = (projectId, commentId) =>
	httpJson('delete', `/projectComments/${commentId}`, {projectId}).catch(
		describeThrow(intl.formatMessage({id: msgs.contentFetchFailed})),
	);

export const getUsers = (query = {}) =>
	httpJson('get', '/users', {
		_limit: '999',
		_sort: 'lastName',
		...query,
	})
		.catch(describeThrow(intl.formatMessage({id: msgs.contentFetchFailed})))
		.then(pipe(prop('data'), map(normalize.user)));
